// Стойността на полетата за плащане (`PaymentFields`) и подразбирането ѝ —
// днес, Банков превод, празно основание.
import dayjs, { type Dayjs } from "dayjs";
import type { DeliveryPaymentMethod } from "../../../../api/inventory";

export type PaymentFieldsValue = {
  paidAt: Dayjs;
  method: DeliveryPaymentMethod;
  reference: string;
};

export const defaultPaymentFields = (): PaymentFieldsValue => ({
  paidAt: dayjs(),
  method: "bank",
  reference: "",
});

export const PAYMENT_LABEL_CLASS = "text-[11px] font-semibold uppercase tracking-[0.1em] text-muted";
